import { TableCellProps } from '@material-ui/core/TableCell';
import { SortDirection } from 'mapistry-shared';
import React from 'react';

export enum RowStatus {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
}

export type BaseTableRow = { id: string; rowStatus?: RowStatus } & Record<
  string | number | symbol,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any
>;

type ReactElementOrString = React.ReactElement | string;

export interface ColumnLayout {
  align?: TableCellProps['align'];
  width?: TableCellProps['width'];
  padding?: TableCellProps['padding'];
}

type WithSorting = {
  isSortable: true;
  sortAriaHeader: string;
};

type WithoutSorting = {
  isSortable?: false;
  sortAriaHeader?: never;
};

export type ColumnSorting = WithSorting | WithoutSorting;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TableColumn<RowEntity extends { [key: string]: any }> =
  ColumnLayout & {
    id: string | number;
    header: ReactElementOrString;
    contents: keyof RowEntity | ((row: RowEntity) => ReactElementOrString);
  } & ColumnSorting;

export type SortState = {
  columnId: string | number;
  direction: SortDirection;
};
